import { render, staticRenderFns } from "./BrandPartsAddLayer.vue?vue&type=template&id=34ac871d&scoped=true&"
import script from "./BrandPartsAddLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsAddLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsAddLayer.vue?vue&type=style&index=0&id=34ac871d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ac871d",
  null
  
)

export default component.exports